import Model from "../Model";
import { StatusForm } from "../../common/Constants";

export interface TFormVersion {
  id: number;
  sendDate?: Date;
  status: string;
  version: number;
  reportingPeriodName: string;
  reportingTypeName: string;
  signatureDate?: Date;
  digitallySigned?: boolean;
}

export interface IFormVersion extends TFormVersion {
  isSendVersion(): boolean;
  isDraftVersion(): boolean;
}

const FormVersion = Model((model: TFormVersion): IFormVersion => {
  const _formVersion: TFormVersion = Object.assign({}, model);

  return {
    get id() {
      return _formVersion.id;
    },

    get sendDate() {
      return _formVersion.sendDate;
    },

    set sendDate(value: any) {
      _formVersion.sendDate = value;
    },

    get status() {
      return _formVersion.status;
    },

    get version() {
      return _formVersion.version;
    },

    get reportingPeriodName() {
      return _formVersion.reportingPeriodName;
    },

    get reportingTypeName() {
      return _formVersion.reportingTypeName;
    },

    get signatureDate() {
      return _formVersion.signatureDate;
    },

    set signatureDate(value: any) {
      _formVersion.signatureDate = value;
    },

    get digitallySigned() {
      return _formVersion.digitallySigned;
    },

    set digitallySigned(value: any) {
      _formVersion.digitallySigned = value;
    },

    isSendVersion() {
      return _formVersion.status === StatusForm.SEND;
    },

    isDraftVersion() {
      return _formVersion.status === StatusForm.DRAFT;
    }
  };
});

export default FormVersion;
